import { fetchUtils } from 'ra-core';
import { logger } from "../observability/LoggerFactory";
import { generateTraceparent } from '../lib/GenerateTraceparent';
import { TokenStorage } from "../auth/TokenStorage";
import { refreshTokens } from '../auth/RefreshTokens';

// Отказ в том виде, в каком он долетает до этого слоя из `fetchUtils.fetchJson`.
interface CaughtHttpFailure {
  // Отсутствует, когда до ответа сервера дело не дошло: сетевой сбой или
  // прерывание запроса кода состояния не несут.
  status?: number;
}

export const tracedHttpClient: typeof fetchUtils.fetchJson = async (url, options = {}) => {
  const doRequest = () => {
    const { traceparent } = generateTraceparent();
    const headers = new Headers(options.headers ?? {});
    if (!headers.has('traceparent')) {
      headers.set('traceparent', traceparent);
    }
    const token = TokenStorage.getAccessToken();
    if (token !== null) {
      headers.set('auth-token', token);
    }
    return fetchUtils.fetchJson(url, { ...options, headers });
  };

  let requestOutcome: Awaited<ReturnType<typeof fetchUtils.fetchJson>>;
  try {
    requestOutcome = await doRequest();
  } catch (error) {
    logger.warn({ err: error, component: "tracedHttpClient" }, "HTTP request failed");
    if ((error as CaughtHttpFailure).status !== 401 || !(await refreshTokens())) {
      throw error;
    }
    requestOutcome = await doRequest();
  }
  return requestOutcome;
};
